import { Dialog } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Typography } from 'procyon-ui'

const NetworkError = ({ Message, Icon, Action, open = false }) => {
  const [dots, setDots] = useState('.')
  useEffect(() => {
    const id = setInterval(() => {
      setDots((s) => (s.length === 3 ? '.' : s + '.'))
    }, 1000)
    return () => clearInterval(id)
  }, [])

  return (
    <Dialog
      open={open}
      PaperProps={{
        className:
          '!m-0 overflow-hidden rounded-2xl w-[min(480px,calc(100vw-32px))] shadow-[0_24px_64px_-16px_rgba(15,23,42,0.25),0_4px_12px_rgba(15,23,42,0.08)]'
      }}
    >
      <div className='h-1 w-full animate-shimmer bg-[linear-gradient(90deg,transparent_0%,var(--color-primary,#4A6CF7)_50%,transparent_100%)] bg-[length:200%_100%]' />
      <div className='flex flex-col items-center px-4 pt-8 pb-6'>
        <div className='flex h-14 w-14 items-center justify-center rounded-full bg-[color-mix(in_srgb,var(--color-red-base,#ef4444)_10%,var(--color-common-bg-base,#ffffff))] animate-pulseRing [&_svg]:text-[26px]'>
          {Icon}
        </div>
        <Typography variant='h4-medium' className='mt-2 text-center text-[var(--color-font-base,#0f172a)]'>
          Reconnecting<span className='inline-block min-w-[24px] text-left'>{dots}</span>
        </Typography>
        <div className='mt-1.5 max-w-[360px] text-center text-[var(--color-font-secondary,#64748b)]'>
          {Message}
        </div>
      </div>
      <div className='flex flex-wrap items-center justify-between gap-3 border-t border-[var(--color-common-border,#e2e8f0)] bg-[var(--color-common-bg-secondary,#f8fafc)] px-3 py-3.5'>
        <div className='flex items-center gap-2'>
          <span className='h-2 w-2 shrink-0 rounded-full bg-[var(--color-primary,#4A6CF7)] animate-blink' />
          <Typography
            variant='body-regular'
            style={{ fontSize: 13, color: 'var(--color-font-secondary, #64748b)' }}
          >
            We're retrying automatically
          </Typography>
        </div>
        {Action}
      </div>
    </Dialog>
  )
}

export default NetworkError
